import {
  HOME_COUNTRY_TO_GROUP, HOME_HERO_ASSETS_PATH, HOME_HERO_PORTRAIT_ISOS, HOME_HERO_PROMO_CODE, HOME_HERO_WIDE_ISOS, IHomeCorridorPreset
} from '../../model/types/home-revamp-types';
import { HOME_NO_WALLET_ISOS, HOME_PARTNERS_BY_ISO, HOME_ROW_LAYOUT_ISOS } from '../../model/types/home-revamp-partners.const';

export type TranslateFn = (key: string, params?: any) => string;

export class HomeRevamp {

  static resolveHeroImage(iso: string): string {
    const key = (iso || '').toUpperCase();
    if (key && HOME_HERO_PORTRAIT_ISOS.indexOf(key) >= 0)
      return `${HOME_HERO_ASSETS_PATH}/portrait/${key.toLowerCase()}.webp`;
    if (key && HOME_HERO_WIDE_ISOS.indexOf(key) >= 0)
      return `${HOME_HERO_ASSETS_PATH}/wide/${key.toLowerCase()}.webp`;
    const group = HOME_COUNTRY_TO_GROUP[key];
    if (group)
      return `${HOME_HERO_ASSETS_PATH}/ethnicity/${group}.webp`;
    return `${HOME_HERO_ASSETS_PATH}/general.webp`;
  }

  static getCorridorPreset(iso: string): IHomeCorridorPreset | null {
    const key = (iso || '').toUpperCase();
    const partners = HOME_PARTNERS_BY_ISO[key];
    if (!partners || !partners.length)
      return null;
    return {
      layout: HOME_ROW_LAYOUT_ISOS.indexOf(key) >= 0 ? 'row' : 'collage',
      partners,
      hasWallets: HOME_NO_WALLET_ISOS.indexOf(key) < 0
    };
  }

  static buildPartnersTagline(hasWallets: boolean, t: TranslateFn): string {
    const methods = [t('page.sendReceiptPage.paymentMethods.bankAccount')];
    if (hasWallets)
      methods.push(t('page.sendReceiptPage.paymentMethods.eWallet'));
    methods.push(t('page.sendSummaryPage.detailsOfficePickup.cashPickUp'));
    const lowered = methods.map((method, index) => index === 0 ? method : method.charAt(0).toLowerCase() + method.slice(1));
    const last = lowered.pop();
    return lowered.length ? `${lowered.join(', ')} ${t('global.policyLinks.and')} ${last}` : last;
  }

  static buildHeroTitleLead(t: TranslateFn): string {
    return t('page.home.hero.title', { receiveCountry: '' }).trim();
  }

  static buildHeroSubtitleHtml(t: TranslateFn): string {
    const termsLink = `<a class="home-hero__terms">${t('page.welcomeCalculator.feeInfoModal.termsLink')}</a>`;
    const subtitle = t('page.welcomeCalculator.subtitle', { promoCode: `<strong>${HOME_HERO_PROMO_CODE}</strong>`, termsLink }).replace(/\*/g, '');
    return subtitle.indexOf(termsLink) >= 0 ? subtitle : `${subtitle} ${termsLink}`;
  }

  static resolveLocale(language: string): string {
    const raw = (language || '').replace('_', '-').toLowerCase();
    return /^[a-z]{2}-[a-z]{2}$/.test(raw) ? raw : 'en-us';
  }

  static initials(firstName: string, lastName: string): string {
    return `${(firstName || '').charAt(0)}${(lastName || '').charAt(0)}`.toUpperCase();
  }

  static resolveDestination(flagEnabled: boolean, userSendingCountry: string, defaultCountryTo: string, countryOfBirth: string): string {
    if (flagEnabled)
      return defaultCountryTo || userSendingCountry || countryOfBirth || null;
    return userSendingCountry || defaultCountryTo || countryOfBirth || null;
  }

  static dampPull(rawDelta: number, maxPull: number = 120, resistance: number = 0.5): number {
    if (rawDelta <= 0)
      return 0;
    return maxPull * (1 - Math.exp((-resistance * rawDelta) / maxPull));
  }
}



// WEBPACK FOOTER //
// ./src/providers/homescreen/home-revamp.ts